import { MEASUREMENT_VIEWPORT_TOOLSET_PLUGIN } from "@/viewport-tools/measurement/plugin";
import { SCALE_VIEWPORT_TOOLSET_PLUGIN } from "@/viewport-tools/scale/plugin";
import { TAGS_VIEWPORT_TOOLSET_PLUGIN } from "@/viewport-tools/tags/plugin";
import type { ViewportToolsetPlugin } from "@/viewport-tools/plugin-types";

export const VIEWPORT_TOOLSET_PLUGINS = [
  SCALE_VIEWPORT_TOOLSET_PLUGIN,
  MEASUREMENT_VIEWPORT_TOOLSET_PLUGIN,
  TAGS_VIEWPORT_TOOLSET_PLUGIN,
] as unknown as ViewportToolsetPlugin[];
